module.exports = __webpack_public_path__ + "static/media/viber.a3fbd41e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/viber.svg
// module id = 29
// module chunks = 0